import axios from '@/components/api/axios';

async function getDeliveryAddressList(bcNo) {
  let data = {
    bcNo: bcNo
  };
  const res = await axios.axiosGet('/api/deliveryAddresses/getList', data);
  return res;
}

async function updateDeliveryAddress(bcNo, deliveryAddressId, sameWithBc001) {
  let data = {
    bcNo: bcNo,
    deliveryAddressId: deliveryAddressId,
    sameWithBc001: sameWithBc001
    // sameWithBc001: true
  };
  console.log(data);
  const res = await axios.axiosPut('/api/deliveryAddresses/updateDefaultBc', data);
  return res;
}

async function createDeliveryAddress(data) {
  console.log(data);
  // let data = {
  //   bcNo: bcNo,
  //   deliveryAddressId: deliveryAddressId,
  //   sameWithBc001: true
  // };
  const res = await axios.axiosPost('/api/deliveryAddresses/add', data);
  return res;
}

export default {
  getDeliveryAddressList,
  updateDeliveryAddress,
  createDeliveryAddress
}



// WEBPACK FOOTER //
// ./src/components/api/deliveryAddress.js